"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.passwordlessValidator = void 0;
const schema_1 = require("../../schema");
const occupation_1 = require("../../concepts/occupation");
const language_1 = require("../../concepts/language");
const stampNumber = schema_1.Schema.stampNumber();
exports.passwordlessValidator = schema_1.Schema.form().properties({
    title: schema_1.Schema.string().optional(),
    firstName: schema_1.Schema.string(),
    lastName: schema_1.Schema.string(),
    phoneNumber: schema_1.Schema.phoneNumber(),
    occupation: occupation_1.occupation,
    stampNumber: schema_1.Schema.ifThen(schema_1.Schema.expression(`{../occupation} === "${occupation_1.Occupation.Doctor}"`), stampNumber),
    defaultLanguage: language_1.language.default(language_1.Locale.HU)
});
exports.validator = exports.passwordlessValidator.properties({
    currentPassword: schema_1.Schema.string().optional(),
    newPassword: schema_1.Schema.string().optional().minLength(8),
    newPasswordAgain: schema_1.Schema.const(schema_1.Schema.reference("../newPassword")).optional()
});
